/**
 * DOM 小工具
 *
 * 刻意不引入框架：这个原型要跑在千元机上，DOM 操作集中在这里，
 * 迁 Cocos 时这一层整体替换掉即可（游戏逻辑都在 shared 与 game/ 里）。
 */

/** HTML 转义：所有来自数据/服务端的文本都要过这一层 */
export function esc(text: unknown): string {
  return String(text ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export function mustFind<T extends Element>(selector: string, root: ParentNode = document): T {
  const found = root.querySelector<T>(selector);
  if (!found) throw new Error(`DOM 节点缺失: ${selector}`);
  return found;
}

export function setHtml(host: Element, html: string): void {
  host.innerHTML = html;
}

/** 事件委托：给动态生成的列表统一挂监听，避免逐个 addEventListener */
export function delegate<T extends HTMLElement>(
  host: Element,
  eventName: string,
  selector: string,
  handler: (element: T) => void,
): () => void {
  const listener = (event: Event): void => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const matched = target.closest<T>(selector);
    if (matched && host.contains(matched)) handler(matched);
  };
  host.addEventListener(eventName, listener);
  return () => host.removeEventListener(eventName, listener);
}

/** 星级字符串（颜色之外还用空心/实心区分） */
export function starsText(stars: number, max = 3): string {
  const filled = Math.max(0, Math.min(max, stars));
  return `<span class="stars">${"★".repeat(filled)}<span class="stars-empty">${"☆".repeat(
    max - filled,
  )}</span></span>`;
}
